import type { CollectionModel } from "@/features/collections/api/models/CollectionModel";
import { useHTTP, useHTTPMutation, type HTTPResponse } from "@/lib/http";
import type { PrepopulateSet } from "@/lib/domain/PrepopulateSet";
import { useQueryClient, type MutationFunction } from "@tanstack/react-query";

export interface CreatePrepopulatedCollectionRequestModel {
	readonly name: string;
	readonly sets: PrepopulateSet[];
	readonly filterFlags: number;
	readonly quantity: number;
	readonly forceEquipmentWeaponQuantity: boolean;
	readonly forceColdFoilQuantity: boolean;
}

export const useCreatePrepopulatedCollection = () => {
	const http = useHTTP("Required");
	const queryClient = useQueryClient();

	const mutationFn: MutationFunction<HTTPResponse<CollectionModel>, CreatePrepopulatedCollectionRequestModel> = requestModel => {
		return http<CollectionModel, CreatePrepopulatedCollectionRequestModel>({
			method: "POST",
			url: "/collection/prepopulated",
			body: requestModel
		});
	};

	return useHTTPMutation({
		mutationFn,
		onSuccess: () => {
			queryClient.invalidateQueries({ queryKey: ["collections"] });
			queryClient.invalidateQueries({ queryKey: ["collectionsPerformanceDelta"] });
		}
	});
};
